import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ISchoolDemographics } from '../models/schoolDemographics';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class SchoolDemographicsService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getSchoolDemographics(buildingId: string): Observable<{has_error: boolean, message: string, data: ISchoolDemographics}> {
        const url = environment.apiBaseUrl + endpoints.getSchoolDemographics.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: ISchoolDemographics}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateSchoolDemographics(buildingId: string, data: Partial<ISchoolDemographics>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateSchoolDemographics.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
